import { render, staticRenderFns } from "./OrderTile.vue?vue&type=template&id=407273b7&scoped=true&"
import script from "./OrderTile.vue?vue&type=script&lang=js&"
export * from "./OrderTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407273b7",
  null
  
)

export default component.exports